/* eslint no-undef: 0 */
/* eslint arrow-parens: 0 */
import React from 'react';
import './index.less';

// 页尾部分
import Footer from '../layout/Footer';
import { FooterDataSource } from '../layout/data.source.js';

export default class ERROR extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      num: 8
    };
  }

  componentDidMount() {
    // 如果匹配不到页面，自动定时请求refer方法，启动8秒倒计时
    this.timer = setInterval(() => {
      const { num } = this.state;
  
      if (num === 0){
        window.location.href = "/"; //跳转的地址
      } else {  
        this.setState({
          num: num -1
        }, () => {
          document.getElementById('show').innerHTML = `Back to <a href='/'>Homepage</a> in ${num} seconds.`; // 显示倒计时 
        });
      }
    }, 1000);
  };

  componentWillUnmount() { 
    if (this.timer != null) { 
      clearInterval(this.timer);
    }
  }

  render() {
    const children = [
      <div
        id="404"
        key="404"
        className="error-page"
      >
        <div className="error-page-container">
          <div className="error-page-main">
            <h3>
              <strong>Tips</strong>
            </h3>
            <div className="error-page-actions">
              <div>
                <h4>Unfortunately, the website you visited was lost! <span id="show"></span></h4>
                <ol>
                <br/> <br/> <br/>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>,
      <Footer 
        id="Footer"
        key="Footer"
        dataSource={FooterDataSource} 
      />
    ];
    
    return (
      <div
        className="templates-wrapper"
        ref={(d) => {
          this.dom = d;
        }}
      >
        {children}
      </div>
    );
  }
}
